import axios from "axios";
import { apiUrl } from "../const";

const Api = axios.create({
	baseURL: apiUrl,
});

Api.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

export function setAuthorization(Authorization) {
	Api.defaults.headers.common.Authorization = Authorization;
}

// Pages publiques : App.js tente une reconnexion silencieuse au montage dès
// qu'un token traîne dans le storage (même expiré/invalide). Un échec de
// cette tentative ne doit jamais éjecter un visiteur anonyme de ces pages
// vers /connexion — seul un vrai formulaire de connexion, ou un token
// invalide sur une page protégée, doit y rediriger.
const PUBLIC_PATHS = ["/", "/onboarding"];
const isPublicPath = (pathname) => PUBLIC_PATHS.some((p) => (p === "/" ? pathname === "/" : pathname.startsWith(p)));

const responseHandler = (response) => {
	if (response.status === 401 && !isPublicPath(window.location.pathname)) {
		window.location = "/connexion"; // sign-in
	}

	return response;
};

const errorHandler = (error) => {
	let requestStrategy = null;
	if (error.config && error.config.data) {
		try {
			requestStrategy = JSON.parse(error.config.data).strategy;
		} catch (e) {
			requestStrategy = null;
		}
	}

	if (
		error.response &&
    error.response.status === 401 &&
    requestStrategy === "jwt" &&
    !window.location.pathname.includes("/connexion") &&
    !isPublicPath(window.location.pathname)
	) {
		window.location = "/connexion"; // sign-in
	}

	if (
		error.response &&
    error.response.status === 502
	) {
		alert("Problème de connexion au serveur. Veuillez réessayer dans quelques instants");
	}

	return Promise.reject(error);
};

Api.interceptors.response.use(
	(response) => responseHandler(response),
	(error) => errorHandler(error),
);

export default Api;
